import React from 'react';
import Image from '../../Atoms/Image/Image';
import Heading from '../../Atoms/Heading/Heading';
import Link from '../../Atoms/Link/Link';
import './DefaultHeader.scss';
import { DELIVERY, excludedPagesAnalytics } from '../../../constants/App';
import _get from 'lodash/get';
import useStore from '../../../store/useStore';
import { CURBSIDE, DEFAULT_STORE, HEADER, SUB_HEADER } from '../../../constants/AnalyticsConstants';
import { getPageName } from '../../../Utils/pageUtils';

interface DefaultHeaderProps {
  defaultHeaderData?: any;
  orderViewModel: any;
  subwayScript?: any;
  analytics:any;
}

const DefaultHeader: React.FC<DefaultHeaderProps> = ({
  defaultHeaderData,
  orderViewModel,
  subwayScript,
  analytics
}) => {
  const [topMargin, setTopMargin] = React.useState<string>('0px');
  const header = document.querySelector('.navbar');
  const headerHeight = _get(header, ['offsetHeight'], 0);
  const header2 = document.querySelector('.defaultHeader__comp');
  const headerHeight2 = _get(header2, ['offsetHeight'], 0);
  const { setHeaderHeight } = useStore();
  const { setAnalyticsProducts, setAttemptTracker, isHeaderLoad } = useStore();

  React.useEffect(() => {
    setHeaderHeight(parseInt(headerHeight) + parseInt(headerHeight2) + 'px');
    setTopMargin(parseInt(headerHeight) + 'px');
  }, [headerHeight, headerHeight2]);

  const checkDeliveryType = () => {
    if (orderViewModel.orderType == DELIVERY) {
      return { icon: defaultHeaderData.deliveryIcon, text: defaultHeaderData.deliveryText };
    }

    if (orderViewModel.orderType == CURBSIDE) {
      return { icon: defaultHeaderData.pickUpIcon, text: defaultHeaderData.crubSideText };
    }
    return { icon: defaultHeaderData.pickUpIcon, text: defaultHeaderData.pickUpText };
  };

  const handleDefaultHeader = () => {
    const pageName = getPageName()
    if(excludedPagesAnalytics.includes(pageName)){
      analytics.defaultStoreHeader()
    }else{
    setAnalyticsProducts({
      clickActionName: DEFAULT_STORE,
      componentTitle: HEADER,
    });
    setAttemptTracker([{ name: SUB_HEADER, isClickable: true }]);
    }
  };
  return (
    isHeaderLoad &&
    defaultHeaderData &&
    orderViewModel.orderType &&
    (orderViewModel.store.address1 || orderViewModel.DeliveryAddress.StreetAddressLine1) && (
      <div className="defaultHeader__comp" style={{ marginTop: topMargin }}>
        <Image imageSources={checkDeliveryType().icon} />
        <Heading
          title={checkDeliveryType().text}
          level="span"
          testAutoId='common-order-type'
          className="defaultHeader__comp--pickup"
        />
        <Link
          text={ orderViewModel.orderType === 'delivery' ? orderViewModel.DeliveryAddress.StreetAddressLine1 : orderViewModel.store.address1}
          href={
            subwayScript && orderViewModel.orderType === 'delivery'
              ? subwayScript?.navigation?.getDeliveryLocatorUrl()
              : subwayScript.navigation.getLocatorUrl()
          }
          onClick={handleDefaultHeader}
          data-testauto-id="defaultHeader-address"
          className="defaultHeader__comp--link"
        />
      </div>
    )
  );
};

export default DefaultHeader;
